import _regeneratorRuntime from "@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(gridInitSagaWorker),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(gridInitSagaWatcher),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(updateGridSagaWorker),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(updateGridSagaWatcher),
    _marked5 = /*#__PURE__*/_regeneratorRuntime.mark(closeGridSagaWorker),
    _marked6 = /*#__PURE__*/_regeneratorRuntime.mark(closeGridSagaWatcher),
    _marked7 = /*#__PURE__*/_regeneratorRuntime.mark(closeAllGridsSagaWorker),
    _marked8 = /*#__PURE__*/_regeneratorRuntime.mark(closeAllGridsSagaWatcher),
    _marked9 = /*#__PURE__*/_regeneratorRuntime.mark(gridApiSagaWorker),
    _marked10 = /*#__PURE__*/_regeneratorRuntime.mark(gridApiSagaWatcher),
    _marked11 = /*#__PURE__*/_regeneratorRuntime.mark(gridUpdateApiSagaWorker),
    _marked12 = /*#__PURE__*/_regeneratorRuntime.mark(gridUpdateApiSagaWatcher),
    _marked13 = /*#__PURE__*/_regeneratorRuntime.mark(gridsSaga);

import { all, call, fork, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { ConstantsUtil } from '@utils';
import { API_GRID_FETCH, CLOSE_ALL_GRIDS_REQUEST, CLOSE_GRID_REQUEST, GRID_INIT_REQUEST, UPDATE_API_GRID_FETCH, UPDATE_GRID_REQUEST } from './grids.action-types';
import { actions } from './grids.actions';

function gridInitSagaWorker(action) {
  return _regeneratorRuntime.wrap(function gridInitSagaWorker$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return put(actions.gridInit({
            gridId: action.payload.gridId,
            items: action.payload.items,
            isError: action.payload.isError,
            isLoading: action.payload.isLoading
          }));

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function gridInitSagaWatcher() {
  return _regeneratorRuntime.wrap(function gridInitSagaWatcher$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return all([takeLatest(GRID_INIT_REQUEST, gridInitSagaWorker)]);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

function updateGridSagaWorker(action) {
  return _regeneratorRuntime.wrap(function updateGridSagaWorker$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return put(actions.gridUpdate({
            gridId: action.payload.gridId,
            items: action.payload.items,
            isError: action.payload.isError,
            isLoading: action.payload.isLoading
          }));

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}

function updateGridSagaWatcher() {
  return _regeneratorRuntime.wrap(function updateGridSagaWatcher$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return all([takeLatest(UPDATE_GRID_REQUEST, updateGridSagaWorker)]);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}

function closeGridSagaWorker(action) {
  return _regeneratorRuntime.wrap(function closeGridSagaWorker$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return put(actions.gridClose({
            gridId: action.payload.gridId
          }));

        case 2:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}

function closeGridSagaWatcher() {
  return _regeneratorRuntime.wrap(function closeGridSagaWatcher$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return all([takeLatest(CLOSE_GRID_REQUEST, closeGridSagaWorker)]);

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}

function closeAllGridsSagaWorker() {
  return _regeneratorRuntime.wrap(function closeAllGridsSagaWorker$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return put(actions.closeAllGrids());

        case 2:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}

function closeAllGridsSagaWatcher() {
  return _regeneratorRuntime.wrap(function closeAllGridsSagaWatcher$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return all([takeLatest(CLOSE_ALL_GRIDS_REQUEST, closeAllGridsSagaWorker)]);

        case 2:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8);
}

function gridApiSagaWorker(action) {
  var response, responseWithData, items;
  return _regeneratorRuntime.wrap(function gridApiSagaWorker$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.prev = 0;
          _context9.next = 3;
          return put(actions.gridInit({
            gridId: action.payload.gridId,
            items: null,
            isError: false,
            isLoading: true
          }));

        case 3:
          _context9.next = 5;
          return call(action.payload.api);

        case 5:
          response = _context9.sent;
          responseWithData = response;

          if (responseWithData !== null && responseWithData !== void 0 && responseWithData.data) {
            if (action.payload.transformResponse) {
              items = action.payload.transformResponse(responseWithData === null || responseWithData === void 0 ? void 0 : responseWithData.data);
            } else {
              items = response === null || response === void 0 ? void 0 : response.data;
            }
          } else {
            if (action.payload.transformResponse) {
              items = action.payload.transformResponse(responseWithData === null || responseWithData === void 0 ? void 0 : responseWithData.data);
            } else {
              items = response;
            }
          }

          _context9.next = 10;
          return put(actions.gridApiSuccess({
            items: items,
            gridId: action.payload.gridId,
            isLoading: false,
            isError: false
          }));

        case 10:
          _context9.next = 12;
          return put({
            type: "".concat(API_GRID_FETCH, "/").concat(ConstantsUtil.actions.ASYNC_SUCCESS),
            payload: items
          });

        case 12:
          _context9.next = 20;
          break;

        case 14:
          _context9.prev = 14;
          _context9.t0 = _context9["catch"](0);
          _context9.next = 18;
          return put(actions.gridApiFailure({
            items: null,
            gridId: action.payload.gridId,
            isLoading: false,
            isError: true
          }));

        case 18:
          _context9.next = 20;
          return put({
            type: "".concat(API_GRID_FETCH, "/").concat(ConstantsUtil.actions.ASYNC_FAILED),
            payload: _context9.t0
          });

        case 20:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9, null, [[0, 14]]);
}

function gridApiSagaWatcher() {
  return _regeneratorRuntime.wrap(function gridApiSagaWatcher$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return all([takeEvery(API_GRID_FETCH, gridApiSagaWorker)]);

        case 2:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked10);
}

function gridUpdateApiSagaWorker(action) {
  var response, responseWithData, items;
  return _regeneratorRuntime.wrap(function gridUpdateApiSagaWorker$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.prev = 0;
          _context11.next = 3;
          return put(actions.gridUpdate({
            gridId: action.payload.gridId,
            isError: false,
            isLoading: true
          }));

        case 3:
          _context11.next = 5;
          return call(action.payload.api);

        case 5:
          response = _context11.sent;
          responseWithData = response;

          if (responseWithData !== null && responseWithData !== void 0 && responseWithData.data) {
            if (action.payload.transformResponse) {
              items = action.payload.transformResponse(responseWithData === null || responseWithData === void 0 ? void 0 : responseWithData.data);
            } else {
              items = response === null || response === void 0 ? void 0 : response.data;
            }
          } else {
            if (action.payload.transformResponse) {
              items = action.payload.transformResponse(responseWithData === null || responseWithData === void 0 ? void 0 : responseWithData.data);
            } else {
              items = response;
            }
          }

          _context11.next = 10;
          return put(actions.gridApiSuccess({
            items: items,
            gridId: action.payload.gridId,
            isLoading: false,
            isError: false
          }));

        case 10:
          _context11.next = 12;
          return put({
            type: "".concat(UPDATE_API_GRID_FETCH, "/").concat(ConstantsUtil.actions.ASYNC_SUCCESS),
            payload: items
          });

        case 12:
          _context11.next = 20;
          break;

        case 14:
          _context11.prev = 14;
          _context11.t0 = _context11["catch"](0);
          _context11.next = 18;
          return put(actions.gridApiFailure({
            items: null,
            gridId: action.payload.gridId,
            isLoading: false,
            isError: true
          }));

        case 18:
          _context11.next = 20;
          return put({
            type: "".concat(UPDATE_API_GRID_FETCH, "/").concat(ConstantsUtil.actions.ASYNC_FAILED),
            payload: _context11.t0
          });

        case 20:
        case "end":
          return _context11.stop();
      }
    }
  }, _marked11, null, [[0, 14]]);
}

function gridUpdateApiSagaWatcher() {
  return _regeneratorRuntime.wrap(function gridUpdateApiSagaWatcher$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return all([takeEvery(UPDATE_API_GRID_FETCH, gridUpdateApiSagaWorker)]);

        case 2:
        case "end":
          return _context12.stop();
      }
    }
  }, _marked12);
}

export default function gridsSaga() {
  return _regeneratorRuntime.wrap(function gridsSaga$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return all([fork(gridInitSagaWatcher), fork(updateGridSagaWatcher), fork(closeGridSagaWatcher), fork(closeAllGridsSagaWatcher), fork(gridApiSagaWatcher), fork(gridUpdateApiSagaWatcher)]);

        case 2:
        case "end":
          return _context13.stop();
      }
    }
  }, _marked13);
}